/** @format */

export * from './lib/compare-grid/compare-grid.component';
